import { render, staticRenderFns } from "./UserPersonal.vue?vue&type=template&id=27dd2df2&"
import script from "./UserPersonal.vue?vue&type=script&lang=js&"
export * from "./UserPersonal.vue?vue&type=script&lang=js&"
import style0 from "./UserPersonal.vue?vue&type=style&index=0&id=27dd2df2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports